module.exports = __webpack_public_path__ + "img/46.9623a226.png";